import React, { useEffect, useRef, useState } from "react";
import Mesh from "../../assets/images/BGmesh2.svg";
import icon from "../../assets/images/PurpleLogo.svg";
import budget from "../../assets/images/budget.png";
import budget2 from "../../assets/images/budget2.png";
import rightArrow from "../../assets/images/right-arrow.png";
// import rightArrow from "../../assets/images/left-arrow.png";
import rightArrow2 from "../../assets/images/right-arrow2.png";
import checklists from "../../assets/images/checklists.png";
import checklists2 from "../../assets/images/checklists2.png";
import asset from "../../assets/images/property-investment.png";
import asset2 from "../../assets/images/property-investment2.png";
import pos from "../../assets/images/pos.png";
import pos2 from "../../assets/images/pos2.png";
import productManagement from "../../assets/images/product-management.png";
import productManagement2 from "../../assets/images/product-management2.png";
import purchase from "../../assets/images/purchase.png";
import purchase2 from "../../assets/images/purchase2.png";
import webManagement from "../../assets/images/web-management.png";
import webManagement2 from "../../assets/images/web-management2.png";
import pieChart from "../../assets/images/pie-chart.png";
import pieChart2 from "../../assets/images/pie-chart2.png";

const Section3 = () => {
  const [hov, setHov] = useState([false, 0]);
  const itemRef = useRef(null);

  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = (e) => {
    const { left, top } = e.target.getBoundingClientRect();
    const x = e.clientX - left;
    const y = e.clientY - top;
    setPosition({ x, y });
  };

  const handleMouseMove = (e) => {
    const { left, top } = e.target.getBoundingClientRect();
    const x = e.clientX - left;
    const y = e.clientY - top;
    setPosition({ x, y });
  };

  const handleMouseLeave = () => {
    setPosition({ x: 0, y: 0 });
  };

  // useEffect(() => ,[]);
  return (<>
    <section
    className="tw-max-w-[100vw] tw-bg-[15rem_0] tw-bg-[length:100vw] tw-bg-no-repeat"
    style={{ backgroundImage: `url(${Mesh})` }}
  >
    <div className="tw-pt-7 xl:tw-pt-16 xl:tw-mt-20">
      <div className="tw-mx-7 lg:tw-mx-10 xl:tw-mx-14 2xl:tw-mx-32">
        <div className="lg:tw-ps-7 2xl:tw-ps-12">
          <div className="ProductSansBold lg:tw-border-l-2 tw-border-[#9925df] xs:tw-ps-4 2xl:tw-ps-7 tw-relative tw-w-fit">
            <h1 className="tw-text-[22px] 2xl:tw-text-[27px] 3xl:tw-text-[33px] tw-text-[#062533] tw-leading-[1] max-2xl:tw-tracking-wide">
              EXCEL YOUR BUSINESS WITH ALL INTEGRATED ERP MODULES
            </h1>
            <h2 className="tw-text-[17px] 2xl:tw-text-[21px] 3xl:tw-text-[25px] ProductSansMedium xl:ProductSansRegular tw-text-[#9925df] tw-leading-[1] tw-tracking-tight tw-mt-3 2xl:tw-mt-6">
              Fuel your business engine with our below integrated modules
            </h2>
            <div className="tw-max-lg:tw-hidden tw-absolute tw-top-0 tw-right-0 tw-translate-x-[125%] tw-translate-y-[-50%]">
              <img className="tw-w-11" src={icon} />
            </div>
          </div>
        </div>
        <div className="tw-py-8 lg:tw-py-14 tw-flex tw-justify-between tw-flex-wrap tw-w-[calc(100%-32px)] lg:tw-w-[calc(100%-56px)] 2xl:tw-w-[calc(100%-96px)] tw-max-w-[1339px] tw-mx-auto">
        <div className="p-2 tw-w-1/4">
          <div
            className="btn-6 tw-bg-[#f7f6f6] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] tw-text-[#333333] tw-p-5 tw-aspect-[0.63] tw-transition tw-delay-75"
            onMouseEnter={(e) =>{
              handleMouseEnter(e)
            setHov([true, 0])
          }}
            onMouseLeave={(e) => {
              setHov([false, 0])
              handleMouseLeave(e)
            }}
      // onMouseMove={handleMouseMove}
          >
              <span className="hovercolor" style={{ top: position.y, left: position.x }}></span>
            <div className="tw-flex tw-gap-3">
              <img
                className="tw-w-14 tw-transition tw-delay-75"
                src={hov[0] && hov[1] === 0 ? budget2 : budget}
                alt=""
                srcSet=""
              />
              <span className="tw-text-xl ProductSansBold tw-tracking-wide tw-self-end">
                Finance
              </span>
            </div>
            <ul className="tw-ps-8 tw-pt-4 tw-pb-3 ProductSansRegular tw-text-sm tw-leading-[1.25]">
              <li>General accounting</li>
              <li>Chart of accounts</li>
              <li>Subheads/Groups</li>
              <li>Journal Entry</li>
              <li>Salary Entry</li>
              <li>Direct Entry</li>
              <li>Accounts Payable</li>
              <li>Accounts Receivables</li>
              <li>Direct Stocks</li>
              <li>Direct Taxes</li>
              <li>Indirect Taxes</li>
              <li>Losses Entry</li>
              <li>Assets Losses/Expenses</li>
              <li>Rectification Entries</li>
              <li>Debit/Credit Notes</li>
            </ul>
            <div className="tw-ps-8 tw-mt-auto">
              <span className="ProductSansMediumItalic tw-text-xs">Read More</span>
              <div className="tw-relative tw-flex tw-items-center tw-w-24 tw--mt-[10px]">
                <hr
                  className={`tw-border-b-[1.5px] tw-border-[#838080] tw-w-full ${
                    hov[0] && hov[1] === 0 && "tw-border-[#C7C4C4]"
                  }`}
                />
                <img
                  className="tw-w-4"
                  src={hov[0] && hov[1] === 0 ? rightArrow2 : rightArrow}
                  alt=""
                  srcSet=""
                />
                <div
                  className={`tw-absolute tw--right-[6px] !tw-border-[1.8px] tw-border-[#838080] tw-rounded-full tw-p-2 ${
                    hov[0] && hov[1] === 0 && "tw-border-[#C7C4C4]"
                  }`}
                ></div>
              </div>
            </div>
           
          </div>
          </div>

          <div className="p-2 tw-w-1/4">
          <div
            className="btn-6 tw-bg-[#f7f6f6] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] tw-text-[#333333] tw-p-5 tw-aspect-[0.63] tw-transition tw-delay-75"
            onMouseEnter={(e) =>{
              handleMouseEnter(e)
            setHov([true, 1])
          }}
            onMouseLeave={(e) => {
              setHov([false, 1])
              handleMouseLeave(e)
            }}
      // onMouseMove={handleMouseMove}
          >
              <span className="hovercolor" style={{ top: position.y, left: position.x }}></span>
  <div className="tw-flex tw-gap-3">
    <img
      className="tw-w-14"
      src={hov[0] && hov[1] === 1 ? asset2 : asset}
      alt=""
      srcSet=""
    />
    <span className="tw-text-xl ProductSansBold tw-tracking-wide tw-self-end">
      Asset
    </span>
  </div>
  <ul className="tw-ps-8 tw-pt-4 tw-pb-3 ProductSansRegular tw-text-sm tw-leading-[1.25]">
    <li>Assest Lifecycle</li>
    <li>Assest Inventory</li>
    <li>{`(Sales and Rentals both)`}</li>
    <li>Asset purchasing</li>
    <li>Asset maintenance</li>
    <li>Selling Assets</li>
    <li>Auto Asset Depreciation</li>
    <li>Asset scrapping</li>
    <li>Asset Value Adjustment</li>
    <li>Asset Reporting</li>
  </ul>
  <div className="tw-ps-8 tw-mt-auto">
    <span className="ProductSansMediumItalic tw-text-xs">Read More</span>
    <div className="tw-relative tw-flex tw-items-center tw-w-24 -tw-mt-[10px]">
      <hr
        className={`tw-border-b-[1.5px] tw-border-[#838080] tw-w-full ${
          hov[0] && hov[1] === 1 && "tw-border-[#C7C4C4]"
        }`}
      />
      <img
        className="tw-w-4"
        src={hov[0] && hov[1] === 1 ? rightArrow2 : rightArrow}
        alt=""
        srcSet=""
      />
      <div
        className={`tw-absolute -tw-right-[6px] !tw-border-[1.8px] tw-border-[#838080] tw-rounded-full tw-p-2 ${
          hov[0] && hov[1] === 1 && "tw-border-[#C7C4C4]"
        }`}
      ></div>
    </div>
  </div>
          </div>
          </div>


          <div className="p-2 tw-w-1/4">
          <div
            className="btn-6 tw-bg-[#f7f6f6] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] tw-text-[#333333] tw-p-5 tw-aspect-[0.63] tw-transition tw-delay-75"
            onMouseEnter={(e) =>{
              handleMouseEnter(e)
            setHov([true, 2])
          }}
            onMouseLeave={(e) => {
              setHov([false, 2])
              handleMouseLeave(e)
            }}
      // onMouseMove={handleMouseMove}
          >
              <span className="hovercolor" style={{ top: position.y, left: position.x }}></span>
  <div className="tw-flex tw-gap-3">
    <img
      className="tw-w-14"
      src={hov[0] && hov[1] === 2 ? checklists2 : checklists}
      alt=""
      srcSet=""
    />
    <span className="tw-text-xl ProductSansBold tw-tracking-wide tw-self-end">
      Inventory
    </span>
  </div>
  <ul className="tw-ps-8 tw-pt-4 tw-pb-3 ProductSansRegular tw-text-sm tw-leading-[1.25]">
    <li>Items/products</li>
    <li>Services</li>
    <li>Price management</li>
    <li>Stock Management</li>
    <li>Barcode</li>
    <li>Losses</li>
    <li>Reports</li>
  </ul>
  <div className="tw-ps-8 tw-mt-auto">
    <span className="ProductSansMediumItalic tw-text-xs">Read More</span>
    <div className="tw-relative tw-flex tw-items-center tw-w-24 -tw-mt-[10px]">
      <hr
        className={`tw-border-b-[1.5px] tw-border-[#838080] tw-w-full ${
          hov[0] && hov[1] === 2 && "tw-border-[#C7C4C4]"
        }`}
      />
      <img
        className="tw-w-4"
        src={hov[0] && hov[1] === 2 ? rightArrow2 : rightArrow}
        alt=""
        srcSet=""
      />
      <div
        className={`tw-absolute -tw-right-[6px] !tw-border-[1.8px] tw-border-[#838080] tw-rounded-full tw-p-2 ${
          hov[0] && hov[1] === 2 && "tw-border-[#C7C4C4]"
        }`}
      ></div>
    </div>
  </div>
          </div>
          </div>

          <div className="p-2 tw-w-1/4">
            <div
            className="btn-6 tw-bg-[#f7f6f6] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] tw-text-[#333333] tw-p-5 tw-aspect-[0.63] tw-transition tw-delay-75"
            onMouseEnter={(e) =>{
              handleMouseEnter(e)
            setHov([true, 3])
          }}
            onMouseLeave={(e) => {
              setHov([false, 3])
              handleMouseLeave(e)
            }}
      // onMouseMove={handleMouseMove}
          >
              <span className="hovercolor" style={{ top: position.y, left: position.x }}></span>
            <div className="tw-flex tw-gap-3">
              <img
                className="tw-w-14"
                src={hov[0] && hov[1] === 3 ? pos2 : pos}
                alt=""
                srcSet=""
              />
              <span className="tw-text-xl ProductSansBold tw-tracking-wide tw-self-end">
                Sales & POS
              </span>
            </div>
            <ul className="tw-ps-8 tw-pt-4 tw-pb-3 ProductSansRegular tw-text-sm tw-leading-[1.25]">
              <li>Quotation module</li>
              <li>Sales Order</li>
              <li>Invoices</li>
              <li>Delivery/ Shipment note</li>
              <li>Sales return</li>
              <li>Debit notes</li>
              <br />
              <li>{`POS(feature)`}</li>
              <li>Price Master</li>
              <li>POS Dashboard</li>
              <li>Stock</li>
              <li>Stock update</li>
              <li>Reports</li>
            </ul>
            <div className="tw-ps-8 tw-mt-auto">
              <span className="ProductSansMediumItalic tw-text-xs">Read More</span>
              <div className="tw-relative tw-flex tw-items-center tw-w-24 -tw-mt-[10px]">
                <hr
                  className={`tw-border-b-[1.5px] tw-border-[#838080] tw-w-full ${
                    hov[0] && hov[1] === 3 && "tw-border-[#C7C4C4]"
                  }`}
                />
                <img
                  className="tw-w-4"
                  src={hov[0] && hov[1] === 3 ? rightArrow2 : rightArrow}
                  alt=""
                  srcSet=""
                />
                <div
                  className={`tw-absolute -tw-right-[6px] !tw-border-[1.8px] tw-border-[#838080] tw-rounded-full tw-p-2 ${
                    hov[0] && hov[1] === 3 && "tw-border-[#C7C4C4]"
                  }`}
                ></div>
              </div>
            </div>
          </div>
          </div>

          <div className="p-2 tw-w-1/4">
          <div
            className="btn-6 tw-bg-[#f7f6f6] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] tw-text-[#333333] tw-p-5 tw-aspect-[0.63] tw-transition tw-delay-75"
            onMouseEnter={(e) =>{
              handleMouseEnter(e)
            setHov([true, 4])
          }}
            onMouseLeave={(e) => {
              setHov([false, 4])
              handleMouseLeave(e)
            }}
      // onMouseMove={handleMouseMove}
          >
              <span className="hovercolor" style={{ top: position.y, left: position.x }}></span>
          <div className="tw-flex tw-gap-3">
            <img
              className="tw-w-14"
              src={hov[0] && hov[1] === 4 ? productManagement2 : productManagement}
              alt=""
              srcSet=""
            />
            <span className="tw-text-xl ProductSansBold tw-tracking-wide tw-self-end">
              Production
            </span>
          </div>
          <ul className="tw-ps-8 tw-pt-4 tw-pb-3 ProductSansRegular tw-text-sm tw-leading-[1.25]">
            <li>Immediate Production</li>
            <li>Estimation</li>
            <li>Job Order</li>
            <li>Indenting</li>
            <li>InProcess</li>
            <li>Direct Entry</li>
            <li>Quality Analysis</li>
            <li>Store</li>
            <li>Losses</li>
            <li>Reports</li>
          </ul>
          <div className="tw-ps-8 tw-mt-auto">
            <span className="ProductSansMediumItalic tw-text-xs">Read More</span>
            <div className="tw-relative tw-flex tw-items-center tw-w-24 -tw-mt-[10px]">
              <hr
                className={`tw-border-b-[1.5px] tw-border-[#838080] tw-w-full ${
                  hov[0] && hov[1] === 4 && "tw-border-[#C7C4C4]"
                }`}
              />
              <img
                className="tw-w-4"
                src={hov[0] && hov[1] === 4 ? rightArrow2 : rightArrow}
                alt=""
                srcSet=""
              />
              <div
                className={`tw-absolute -tw-right-[6px] !tw-border-[1.8px] tw-border-[#838080] tw-rounded-full tw-p-2 ${
                  hov[0] && hov[1] === 4 && "tw-border-[#C7C4C4]"
                }`}
              ></div>
            </div>
          </div>
        </div>
        </div>

        <div className="p-2 tw-w-1/4">
        <div
            className="btn-6 tw-bg-[#f7f6f6] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] tw-text-[#333333] tw-p-5 tw-aspect-[0.63] tw-transition tw-delay-75"
            onMouseEnter={(e) =>{
              handleMouseEnter(e)
            setHov([true, 5])
          }}
            onMouseLeave={(e) => {
              setHov([false, 5])
              handleMouseLeave(e)
            }}
      // onMouseMove={handleMouseMove}
          >
              <span className="hovercolor" style={{ top: position.y, left: position.x }}></span>
          <div className="tw-flex tw-gap-3">
            <img
              className="tw-w-14"
              src={hov[0] && hov[1] === 5 ? purchase2 : purchase}
              alt=""
              srcSet=""
            />
            <span className="tw-text-xl ProductSansBold tw-tracking-wide tw-self-end">
              Purchase
            </span>
          </div>
          <ul className="tw-ps-8 tw-pt-4 tw-pb-3 ProductSansRegular tw-text-sm tw-leading-[1.25]">
            <li>Purchase order</li>
            <li>Purchase returns</li>
            <li>GRN</li>
            <li>SCN</li>
            <li>Bill of entry</li>
            <li>Credit Notes</li>
            <li>Reports</li>
          </ul>
          <div className="tw-ps-8 tw-mt-auto">
            <span className="ProductSansMediumItalic tw-text-xs">Read More</span>
            <div className="tw-relative tw-flex tw-items-center tw-w-24 -tw-mt-[10px]">
              <hr
                className={`tw-border-b-[1.5px] tw-border-[#838080] tw-w-full ${
                  hov[0] && hov[1] === 5 && "tw-border-[#C7C4C4]"
                }`}
              />
              <img
                className="tw-w-4"
                src={hov[0] && hov[1] === 5 ? rightArrow2 : rightArrow}
                alt=""
                srcSet=""
              />
              <div
                className={`tw-absolute -tw-right-[6px] !tw-border-[1.8px] tw-border-[#838080] tw-rounded-full tw-p-2 ${
                  hov[0] && hov[1] === 5 && "tw-border-[#C7C4C4]"
                }`}
              ></div>
            </div>
          </div>
        </div>
        </div>
        <div className="p-2 tw-w-1/4">
        <div
            className="btn-6 tw-bg-[#f7f6f6] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] tw-text-[#333333] tw-p-5 tw-aspect-[0.63] tw-transition tw-delay-75"
            onMouseEnter={(e) =>{
              handleMouseEnter(e)
            setHov([true, 6])
          }}
            onMouseLeave={(e) => {
              setHov([false, 6])
              handleMouseLeave(e)
            }}
      // onMouseMove={handleMouseMove}
          >
              <span className="hovercolor" style={{ top: position.y, left: position.x }}></span>
        <div className="tw-flex tw-gap-3">
          <img
            className="tw-w-14"
            src={hov[0] && hov[1] === 6 ? webManagement2 : webManagement}
            alt=""
            srcSet=""
          />
          <span className="tw-text-xl ProductSansBold tw-tracking-wide tw-self-end">
            Masters
          </span>
        </div>
        <ul className="tw-ps-8 tw-pt-4 tw-pb-3 ProductSansRegular tw-text-sm tw-leading-[1.25]">
          <li>Admin Master</li>
          <li>Account Master</li>
          <li>Generic Master</li>
          <li>Inventory Master</li>
        </ul>
        <div className="tw-ps-8 tw-mt-auto">
          <span className="ProductSansMediumItalic tw-text-xs">Read More</span>
          <div className="tw-relative tw-flex tw-items-center tw-w-24 -tw-mt-[10px]">
            <hr
              className={`tw-border-b-[1.5px] tw-border-[#838080] tw-w-full ${
                hov[0] && hov[1] === 6 && "tw-border-[#C7C4C4]"
              }`}
            />
            <img
              className="tw-w-4"
              src={hov[0] && hov[1] === 6 ? rightArrow2 : rightArrow}
              alt=""
              srcSet=""
            />
            <div
              className={`tw-absolute -tw-right-[6px] !tw-border-[1.8px] tw-border-[#838080] tw-rounded-full tw-p-2 ${
                hov[0] && hov[1] === 6 && "tw-border-[#C7C4C4]"
              }`}
            ></div>
          </div>
        </div>
      </div>
      </div>

      <div className="p-2 tw-w-1/4">
      <div
            className="btn-6 tw-bg-[#f7f6f6] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] tw-text-[#333333] tw-p-5 tw-aspect-[0.63] tw-transition tw-delay-75"
            onMouseEnter={(e) =>{
              handleMouseEnter(e)
            setHov([true, 7])
          }}
            onMouseLeave={(e) => {
              setHov([false, 7])
              handleMouseLeave(e)
            }}
      // onMouseMove={handleMouseMove}
          >
              <span className="hovercolor" style={{ top: position.y, left: position.x }}></span>
        <div className="tw-flex tw-gap-3">
          <img
            className="tw-w-14"
            src={hov[0] && hov[1] === 7 ? pieChart2 : pieChart}
            alt=""
            srcSet=""
          />
          <span className="tw-text-xl ProductSansBold tw-tracking-wide tw-self-end">
            Reports
          </span>
        </div>
        <ul className="tw-ps-8 tw-pt-4 tw-pb-3 ProductSansRegular tw-text-sm tw-leading-[1.25]">
          <li>Trial Balance</li>
          <li>Profit and Loss statement</li>
          <li>Balance Sheet</li>
          <li>Ledger View report</li>
          <li>Bank Ledgers</li>
          <li>Vendor Report</li>
          <li>Customer report</li>
          <li>Inventory report</li>
          <li>Stock report</li>
          <li>Damage report</li>
          <li>Consolidate report</li>
          <li>Daily Sales report</li>
          <li>Customise Sales report</li>
          <li>Sales return report</li>
          <li>HSN Summary</li>
          <li>Overdues</li>
        </ul>
        <div className="tw-ps-8 tw-mt-auto">
          <span className="ProductSansMediumItalic tw-text-xs">Read More</span>
          <div className="tw-relative tw-flex tw-items-center tw-w-24 -tw-mt-[10px]">
            <hr
              className={`tw-border-b-[1.5px] tw-border-[#838080] tw-w-full ${
                hov[0] && hov[1] === 7 && "tw-border-[#C7C4C4]"
              }`}
            />
            <img
              className="tw-w-4"
              src={hov[0] && hov[1] === 7 ? rightArrow2 : rightArrow}
              alt=""
              srcSet=""
            />
            <div
              className={`tw-absolute -tw-right-[6px] !tw-border-[1.8px] tw-border-[#838080] tw-rounded-full tw-p-2 ${
                hov[0] && hov[1] === 7 && "tw-border-[#C7C4C4]"
              }`}
            ></div>
          </div>
        </div>
      </div>
      </div>
        </div>
      </div>
    </div>
  </section>
                  


  </>);
};

export default Section3;
